import { useRecoilState, useRecoilValue } from "recoil";
import {
  bigQueryAccessTokenState,
  deviceListState,
  deviceLogListState,
  songListState,
} from "../atom/atom";
import { useEffect, useState } from "react";
import { fetchAndSetData, fetchDeviceLogList } from "../api/fetch.api";
import { Collections, DeviceLog, Genre, ISongLog } from "../types/type";
import { db } from "../firebase/firebaseConfig";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import axios, { AxiosResponse } from "axios";
import {
  QUERY0,
  QUERY1,
  QUERY_FINAL,
  QUERY_SONG_PLAY_START,
  endpoint,
} from "../module/bigQuery";
import { BigQueryResponse, Row } from "../types/bigQuery.type";
import { formatData, UserSongData } from "../module/formatData";
import { GenresToAdd, updateDeviceTagList } from "../api/update.api";

async function fetchBigQueryData(accessToken: string): Promise<Row[]> {
  try {
    const response = await axios.post(
      endpoint,
      { query: QUERY_FINAL, useLegacySql: false },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data.rows;
  } catch (err: any) {
    console.error(err.message);
    throw err;
  }
}

function determineGenresToAdd(
  formattedData: UserSongData[]
): Record<string, string[]> {
  const genresToAddMap: Record<string, string[]> = {};

  formattedData.forEach((userSongData) => {
    const genresToAdd: string[] = [];

    Object.keys(userSongData).forEach((key) => {
      if (key.startsWith("song_play_")) {
        const genreCounts = userSongData[key as keyof UserSongData];

        Object.entries(genreCounts).forEach(([genre, count]) => {
          if (count >= 10 && !genresToAdd.includes(genre)) {
            genresToAdd.push(genre);
          }
        });
      }
    });

    if (genresToAdd.length > 0) {
      genresToAddMap[userSongData.userId] = genresToAdd;
    }
  });

  return genresToAddMap;
}

function DeviceLogPage() {
  const [deviceLogList, setDeviceLogList] = useRecoilState(deviceLogListState);

  const totalSongList = useRecoilValue(songListState);
  const bigQueryAccessToken = useRecoilValue(bigQueryAccessTokenState);

  const [checkResults, setCheckResults] = useState<
    { deviceId: string; result: boolean; failedConditions?: number[] }[]
  >([]);
  const [logResult, setLogResult] = useState<Row[]>([]);

  useEffect(() => {
    fetchAndSetData(fetchDeviceLogList, setDeviceLogList);
  }, []);

  // bidQuery에서 데이터 받아오는 로직
  useEffect(() => {
    // query 날리는 로직
    const fetchData = async (accessToken: string) => {
      try {
        const response: BigQueryResponse = await axios.post(
          endpoint,
          { query: QUERY_FINAL, useLegacySql: false },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setLogResult(response.data.rows);
        console.log("response : ", response);
      } catch (err: any) {
        console.error(err.message);
      }
    };

    if (bigQueryAccessToken) fetchData(bigQueryAccessToken);
  }, [bigQueryAccessToken]);

  useEffect(() => {
    if (!logResult.length) return;

    const formattedData = formatData(logResult, totalSongList);
    console.log(formattedData);
  }, [logResult]);

  // useEffect(() => {
  //   if (!logResult.length) return;

  //   const formattedData = formatData(logResult, totalSongList);
  //   console.log(formattedData);

  //   const genresToAddMap = determineGenresToAdd(formattedData);

  //   if (Object.keys(genresToAddMap).length > 0) {
  //     if (Object.keys(genresToAddMap).length > 0) {
  //       console.log("Processing genresToAddMap:", genresToAddMap);
  //       for (const [userId, genres] of Object.entries(genresToAddMap)) {
  //         const genresToAdd: GenresToAdd = { userId, genres };
  //         updateDeviceTagList(genresToAdd);
  //       }
  //     } else {
  //       console.log("No genres to add.");
  //     }
  //   }
  // }, [logResult, totalSongList]);

  return (
    <>
      <div>
        <h2>Device Log Check Results</h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {checkResults.map((result) => (
            <div
              key={result.deviceId}
              style={{ borderBottom: "1px solid black" }}
            >
              <p>Device ID: {result.deviceId}</p>
              <p>Check Result: {result.result ? "Passed" : "Failed"}</p>
              {result.failedConditions && (
                <p>Failed Conditions: {result.failedConditions.join(", ")}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default DeviceLogPage;
